var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"area-setting-header"},[_c('instruction-icon'),_c('div',{staticClass:"aisea-text-16-400-black"},[_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }